import React, { useContext } from 'react'
import { Col, Popover, Row } from 'antd'
import { formatPhoneNumber } from 'react-phone-number-input'
import GlobalContext from '../GlobalContext'

export const DisplayContact = ({ fields }) => {
  const { screens } = useContext(GlobalContext)
  const span = screens.xs ? 6 : 24

  const value = (field) => (
    field.field_type === 'phone' ? formatPhoneNumber(field.value) : field.value
  )

  return (
    <Row >
      {fields?.map((field) => (
        <Col span={span} key={`contact-${field.id}`}>
          {field.description &&
            <Popover content={field.description}>
              {screens.xs &&
                <span>{field.description} : </span>
              }
              {value(field)}
            </Popover>
          }
          {!field.description && value(field)}
        </Col>
      ))}
    </Row>
  )
}
